module.exports = __webpack_public_path__ + "img/bg_footer03.846165fb.jpg";